<!--
 * @Desc: 学校新闻
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-06 09:11:21
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="common-common-news">
        <!-- 菜单 -->
        <menuCommon :active="active"></menuCommon>
        <!-- 内容区 -->
        <BreadCrumb :objectData="objectData"></BreadCrumb>
        <section class="common-news">
            <div class="container">
                <div class="news-hold">
                    <MenuVertical :active="active"></MenuVertical>
                    <div class="news-list">
                        <div
                            class="news-item"
                            v-for="item in 6"
                            @click="toDetail(item)"
                        >
                            <div class="common-time">
                                2023/3/ <span>26</span>
                            </div>
                            <div class="common-thu">
                                <img
                                    class="thu"
                                    src="../../public/statics/images/Index/icon-pic.jpg"
                                />
                            </div>
                            <div class="common-info">
                                <div class="common-title ellipsis1">
                                    中学举行物理学科优质课比赛…
                                </div>
                                <div class="common-desc ellipsis2">
                                    为深化课堂教学改革，优化课堂教学结构，加强教师对新教材的理解与把握，近日，我校开展了物理学科优质课决赛…
                                </div>
                            </div>
                        </div>
                        <div class="pagination">
                            <el-pagination
                                background
                                @current-change="handleQueryEvent"
                                :current-page.sync="queryParam.page"
                                :page-size="queryParam.size"
                                layout="prev, pager, next, jumper"
                                :total="queryParam.total"
                            >
                            </el-pagination>
                        </div>
                    </div>
                    <div class="recommend-list">
                        <LastRecommend
                            :recommendData="recommendData"
                        ></LastRecommend>
                    </div>
                </div>
            </div>
        </section>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
    </div>
</template>

<script>
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import RecommendedRead from "./../components/Common/RecommendedRead.vue";
import MenuVertical from "./../components/Common/MenuVertical.vue";
import LastRecommend from "./../components/Common/LastRecommend.vue";
export default {
    name: "home",
    data() {
        return {
            // 菜单选中
            active: this.$route.query.active,
            recommendData: {},
            // 栏目详情
            cateData:'',
            // 面包屑展示数据
            objectData: {
                title: "",
                navArray: [
                ],
                thu:''
            },
            // 顶部图片
            imageUrl: require("../../public/statics/images/Banner/banner1.jpg"),
            queryParam: {
                token: this.Cookies.get("token"),
                ks_id: "",
                total: 1000,
                page: 1,
                size: 10,
            },
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
        RecommendedRead,
        MenuVertical,
        LastRecommend,
    },
    created() {
        this.cateDetail()
    },
    mounted() {
        $("html,body").scrollTop(0);
    },
    beforeDestroy() {},
    methods: {
        // 栏目详情 面包屑展示
        cateDetail(){
            let that = this
            that.$api.index.cateDetail({id:this.$route.query.active}).then((res) => {
                if (res.code == 200) {
                    that.cateData = res.result
                    that.objectData.title = that.cateData.name
                    that.objectData.navArray = that.cateData.breadcrumb
                    that.objectData.thu = that.cateData.thumb
                }
            })
        },
        /**
         * @name: 跳转详情
         * @param {*} item
         * @return {*}
         * @desc: 跳转详情
         */
        toDetail(item) {
            console.log(item);
            this.$toPath("/NewsDetail");
        },
        /**
         * @name: 搜索
         * @return {*}
         * @desc:
         */
        searchClick() {
            this.queryParam.pageNo = 1;
            this.handleQueryEvent();
        },
        /**
         * @name: 调用接口 查询数据
         * @return {*}
         * @desc:
         */
        handleQueryEvent() {
            // 调用接口
            console.log("调用接口");
            let that = this;
            // that.$api.index
            //     .detailStudent(that.queryParam)
            //     .then(function (response) {
            //         if (response.code === 200) {
            //             // console.log(response.result.list)
            //             that.tableData = response.result.list;
            //             that.queryParam.total = response.result.total;
            //         }
            //     });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.common-common-news {
    background: #f0f2f5 no-repeat top center;
}
/*  */
.common-common-news .common-news .container {
    margin-top: 30px;
}
.common-common-news .common-news .container .news-hold {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    margin-bottom: 30px;
}
.common-common-news .container .news-hold .news-list {
    flex: 1;
    background: #ffffff;
    padding: 16px;
    padding-right: 0;
}
.common-common-news .news-list .news-item {
    display: flex;
    margin-bottom: 10px;
    cursor: pointer;
    padding: 14px 0;
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.common-common-news .news-list .news-item .common-time {
    font-size: 16px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #999999;
    position: relative;
    padding-top: 8px;
    padding-left: 8px;
}
.common-common-news .news-list .news-item .common-time::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #e22f24;
}
.common-common-news .news-list .news-item .common-time span {
    font-size: 26px;
    color: #e22f24;
}
.common-common-news .news-list .news-item .common-thu {
    width: 136px;
    height: 90px;
    margin-left: 24px;
    margin-right: 14px;
}
.common-common-news .news-list .news-item .common-thu .thu {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.common-common-news .news-list .news-item .common-info {
    flex: 1;
    padding-right: 20px;
}
.common-common-news .news-list .news-item .common-info .common-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    margin-top: 10px;
    margin-bottom: 24px;
}
.common-common-news .news-list .news-item .common-info .common-desc {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 15px;
    color: rgba(102, 102, 102, 1);
}
/* 滑入效果 */
.common-common-news .news-list .news-item:hover {
    background: url(../../public/statics/images/Teachers/icon-bg.png) no-repeat right bottom #e22f24;
}
.common-common-news .news-list .news-item:hover .common-time::after {
    background: #ffffff;
}
.common-common-news .news-list .news-item:hover .common-time {
    color: #ffffff;
}
.common-common-news .news-list .news-item:hover .common-time span {
    color: #ffffff;
}
.common-common-news .news-list .news-item:hover .common-info .common-title {
    color: rgba(255, 255, 255, 1);
}
.common-common-news .news-list .news-item:hover .common-info .common-desc {
    color: #ffffff;
}
/* 滑入end */
.common-common-news .pagination {
    text-align: center;
    margin: 60px 0;
}
.common-common-news
    /deep/
    .el-pagination.is-background
    .el-pager
    li:not(.disabled).active {
    background: #e22f24;
}
/*  */
.common-common-news .container .news-hold .recommend-list {
    width: 394px;
    background: #ffffff;
    padding-left: 50px;
    padding-top: 16px;
}
</style>